export default __webpack_public_path__ + "static/media/icon-clear-on.e400b9d0.svg";